export default __webpack_public_path__ + "static/media/YoungGeraldBriefcase.1b63c8d4.jpg";